import React from "react";
import PdfViewer from "../../PdfViewer";

const PythonTema1 = () => {
  /*const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema1_Introduccion.pdf`;*/
  const pdfUrl = "/pdf/Tema1_Introduccion.pdf";

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Tema 1: Introducción</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PythonTema1;
